import { mutate } from 'swr';
import axios from 'axios';
import { Notistack } from '@shared/components/Notistack/Notistack';
import { EC_SERVICE } from '@shared/constants/apiConfig';
import { getError } from '@shared/utils/helpers';
import { IWorkflowCommunication } from './types';

const WORKFLOW_COMMUNICATION_PATH = '/workflow-service/communications';
const COMMUNICATION_EMAILS_CONFIGURATION = `${EC_SERVICE.ENTERPRISECOMMUNICATION}/emailconfiguration`;
const COMMUNICATION_SIDS_CONFIGURATION = `${EC_SERVICE.ENTERPRISECOMMUNICATION}/sidconfiguration`;

export const requestCreateCommunication = (communicationPayload: Partial<IWorkflowCommunication>) => {
  return mutate(WORKFLOW_COMMUNICATION_PATH, async (): Promise<void> => {
    try {
      await axios.post(WORKFLOW_COMMUNICATION_PATH, communicationPayload);
      Notistack.successMessage('Customer Communication - Created Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestUpdateCommunication = (communicationPayload: IWorkflowCommunication) => {
  const path = `${WORKFLOW_COMMUNICATION_PATH}/${communicationPayload.id}`;

  return mutate(WORKFLOW_COMMUNICATION_PATH, async (): Promise<void> => {
    try {
      await axios.put(path, communicationPayload);
      Notistack.successMessage('Customer Communication - Updated Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestDeleteCommunication = (communicationId: string) => {
  const path = `${WORKFLOW_COMMUNICATION_PATH}/${communicationId}`;

  return mutate(WORKFLOW_COMMUNICATION_PATH, async (): Promise<void> => {
    try {
      await axios.delete(path);
      Notistack.successMessage('Customer Communication - Deleted Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestCreateEmailConfig = async (email: string) => {
  const path = `${COMMUNICATION_EMAILS_CONFIGURATION}`;
  try {
    await axios.post(path, { email });
    Notistack.successMessage('Email Configuration - Created Successfully');
  } catch (err) {
    const error = getError(err);
    Notistack.generalError(error);
    return { error };
  }
};

export const requestUpdateEmailConfig = async (id: string, email: string) => {
  const path = `${COMMUNICATION_EMAILS_CONFIGURATION}/${id}`;
  try {
    await axios.put(path, { id, email });
    Notistack.successMessage('Email Configuration - Updated Successfully');
  } catch (err) {
    const error = getError(err);
    Notistack.generalError(error);
    return { error };
  }
};

export const requestDeleteEmailConfig = async (id: string) => {
  const path = `${COMMUNICATION_EMAILS_CONFIGURATION}/${id}`;
  try {
    await axios.delete(path);
    Notistack.successMessage('Email Configuration - Deleted Successfully');
  } catch (err) {
    Notistack.generalError(getError(err));
  }
};

export const requestCreateSidConfig = async (source: string, sid: string) => {
  const path = `${COMMUNICATION_SIDS_CONFIGURATION}`;
  try {
    await axios.post(path, { source, sid });
    Notistack.successMessage('SID Configuration - Created Successfully');
  } catch (err) {
    const error = getError(err);
    Notistack.generalError(error);
    return { error };
  }
};

export const requestUpdateSidConfig = async (id: string, source: string, sid: string) => {
  const path = `${COMMUNICATION_SIDS_CONFIGURATION}/${id}`;
  try {
    await axios.put(path, { id, source, sid });
    Notistack.successMessage('SID Configuration - Updated Successfully');
  } catch (err) {
    const error = getError(err);
    Notistack.generalError(error);
    return { error };
  }
};

export const requestDeleteSidConfig = async (id: string) => {
  const path = `${COMMUNICATION_SIDS_CONFIGURATION}/${id}`;
  try {
    await axios.delete(path);
    Notistack.successMessage('SID Configuration - Deleted Successfully');
  } catch (err) {
    Notistack.generalError(getError(err));
  }
};
